module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dN9VG"))).then(() => parcelRequire('3a9aZ'));